import { Cookies } from 'react-cookie';
import { getUserFromCookie, getTokenCookie } from '@helpers/authUtils';
import Api from '@helpers/api';
import { endpoints } from '@configs/endpoints';
import { dispatch } from './store';

export const SET_PROFILE = 'SET_PROFILE';
export const LOGIN_WITH_GOOGLE = 'LOGIN_WITH_GOOGLE';
export const LOGIN_WITH_GOOGLE_FAIL = 'LOGIN_WITH_GOOGLE_FAIL';
export const LOGIN_WITH_GOOGLE_SUCCESS = 'LOGIN_WITH_GOOGLE_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';

export const setProfile = user => {
  (new Cookies()).set('user', JSON.stringify(user), { path: '/' });
  dispatch({ type: SET_PROFILE, data: user });
};

export const loginWithGoogle = (token) => {
  dispatch({ type: LOGIN_WITH_GOOGLE });
  Api({
    endpoint: endpoints.loginWithGoogle(),
    data: { token },
    onSuccess: (response) => {
      (new Cookies()).set('token', JSON.stringify({ token: response.token }), { path: '/' });
      (new Cookies()).set('user', JSON.stringify(response.user), { path: '/' });
      dispatch({ type: LOGIN_WITH_GOOGLE_SUCCESS, data: response });
    },
    onFail: (error) => dispatch({ type: LOGIN_WITH_GOOGLE_FAIL, error }),
  });
};

export const logoutUser = (history) => {
  dispatch({ type: LOGOUT_USER });
  (new Cookies()).remove('user');
  (new Cookies()).remove('token');
  if (!history) {
    window.location = '/login';
  } else {
    history.push('/login');
  }
};

const INIT_STATE = {
  profile: getUserFromCookie(),
  token: getTokenCookie(),
  is_loading: false,
};

// eslint-disable-next-line complexity
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_PROFILE:
      return {
        ...state, profile: action.data,
      };
    case LOGIN_WITH_GOOGLE:
      return {
        ...state, is_loading: true, error: null,
      };
    case LOGIN_WITH_GOOGLE_FAIL:
      return {
        ...state, is_loading: false, error: action.error,
      };
    case LOGIN_WITH_GOOGLE_SUCCESS:
      return {
        ...state, is_loading: false, token: { token: action.data.token }, profile: action.data.user,
      };
    default: return { ...state };
  }
};
